<label>
    <input xmAriaDescBy xmAriaInvalid type="checkbox" (click)="toggleSelected($any($event.target).checked)" [id]="inputId"
        name="payment_checkbox" [checked]="isSelected" [attr.aria-disabled]="disabled" [ngClass]="{'error' : !isSelected && error}"/>
    <div class="main-label" *ngIf="label">
        <cms-text class="description" [originalText]="label"></cms-text>
    </div>
</label>